import './topbar.css';
import { Search , Person , Chat , Notifications } from '@material-ui/icons';
import { Link } from "react-router-dom";
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

export default function Topbar(){


    const { user } = useContext(AuthContext);
    
    const PF = process.env.REACT_APP_PUBLIC_FOLDER;

    return (

        <div className="topbarContainer">
            <div className="topbarLeft">
                <Link to="/" style={{ textDecoration:"none" }}>
                    <img src ={ PF + "app_icon.png" } className="logoImg" alt="" />
                    <span className="logo">LetsConnect</span>
                </Link>
            </div>
            <div className="topbarCenter">
                <div className="searchbar">
                    <Search className="searchIcon"/>
                    <input placeholder="Search for a friend , post or videos" 
                        className="searchInput" />
                </div>
            </div>
            <div className="topbarRight">
                <div className="topbarLinks" >
                    <span className="topbarLink">Homepage</span>
                    <span className="topbarLink">Timeline</span>
                </div>
                <div className="topbarIcons">
                    <div className="topbarIconItem">
                        <Person />
                        <span className="topbarIconBadge">1</span>
                    </div>
                    <div className="topbarIconItem">
                        <Link to ="/messenger" style = {{ color : "white" }}>
                            <Chat />
                            <span className="topbarIconBadge">2</span>
                        </Link>
                    </div>
                    <div className="topbarIconItem">
                        <Notifications />
                        <span className="topbarIconBadge">3</span>
                    </div>
                </div>
                <Link to = { `/profile/${ user.username }` }>
                    <img 
                        className="topbarImg" 
                        src={
                            user.profilePicture ? PF + user.profilePicture
                            : PF + "person/noAvatar.png" 
                            } 
                        alt="" />
                 </Link>
            </div>
        </div>
    )
}